import Marquee from "react-fast-marquee";
import styles from './groupCarousel.module.css';
import { useState } from "react";
function GroupCarousel({ setModalImage }) {
    const groups = [
        { name: "Blaue Gruppe", image: "/images/ogs/gruppen/blau.jpg", persons: "Simon Mohr, Birgit Schumacher", missing: "Myriam Haacks" },
        { name: "Gelbe Gruppe", image: "/images/ogs/gruppen/gelb.jpg", persons: "Monika Papke-Tepper, Daniela Neußer" },
        { name: "Lila Gruppe", image: "/images/ogs/gruppen/lila.jpg", persons: "Paola Baiamonte, Jonas Dohmann" },
        { name: "Orange Gruppe", image: "/images/ogs/gruppen/orange.jpg", persons: "Andrea Borutta, Brigitte Budzyn" },
        { name: "Rote u. Grüne Gruppe", image: "/images/ogs/gruppen/rotgruen.jpg", persons: "Juliane Pingsmann, Brigitte Winterscheidt" },
        { name: "Türkise Gruppe", image: "/images/ogs/gruppen/tuerkis.jpg", persons: "Carmen Burgunder, Katrin Alecke" },
        { name: "Team Eudenbach", image: "/images/ogs/gruppen/eudenbach.jpg", persons: "Birgit Kreutz, Bettina Kleemann, Sonja Kuck", missing: "Vera Pietsch, Valerie Fischer, Marita Jühlen" },
        { name: "Team Küche", image: "/images/ogs/gruppen/kueche.jpg", persons: "Ulrike Euskirchen, Petra Meurer, Sawsan Alshmalieh" },
        { name: "Azubis / FSJ'ler", image: "/images/ogs/gruppen/fsjAzubis.jpg", persons: "Julian Hugger, Senta Vasilev, Anjuly Pennartz", missing: "Amos Katernberg" },
        { name: "Ergänzungskräfte", image: "/images/ogs/gruppen/aushilfen.jpg", persons: "Patrick Rüth, Noureddine Benidir, Simon Mohr" },
    ];

    const shuffled = [...groups].sort(() => Math.random() - 0.5);

    return (
        <>
            <Marquee className={styles.banner} pauseOnHover={true} speed={40}>

                <div className={styles.content}>
                    {shuffled.map((item, index) => (
                        <div className={styles.item} key={index}>
                            <h3>{item.name}</h3>
                            <img className={styles.img} src={`${process.env.PUBLIC_URL}${item.image}`} alt={item.name} onClick={() => setModalImage(item.image)} />
                            <div className={styles.itemText}>
                                <p>v.l.n.r.: {item.persons}</p>
                                {item.missing && (
                                    <div>
                                        <p className={styles.missing}>fehlend: {item.missing}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </Marquee>
        </>

    );
}

export default GroupCarousel;
